module.exports = __webpack_public_path__ + "img/solicitar_factura_icon.png";